export const orderStatusOptions = {
  concept: 'Concept',
  ordered: 'Besteld',
  confirmed: 'Bevestigd',
  delivered: 'Geleverd',
  cancelled: 'Geannuleerd',
}
export type OrderStatus = keyof typeof orderStatusOptions

export class Order {
  constructor(
    public readonly id: string,
    public readonly projectId: string,
    public readonly quoteId: string,
    public readonly supplierRelationId: string|null,
    public readonly supplierContactId: string|null,
    public readonly orderedByUserId: string|null,
    public readonly orderNumber: string,
    public readonly amount: number,
    public readonly price: number,
    public readonly status: OrderStatus,
    public readonly orderDate: Date|null,
    public readonly requestDate: Date|null,
    public readonly deliveryDate: Date|null,
    public readonly sentAt: Date|null,
    public readonly vatRateId: string,
    public readonly ledgerCodeId: string,
    public readonly description: string|null,
    public readonly remark: string|null,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
  ) {}

  static fromJson(json: any): Order {
    return new Order(
      json['id'],
      json['project_id'],
      json['quote_id'],
      json['supplier_relation_id'] ?? null,
      json['supplier_contact_id'] ?? null,
      json['ordered_by_user_id'] ?? null,
      json['order_number'],
      json['amount'],
      json['price'],
      json['status'],
      json['order_date'] ? new Date(json['order_date']) : null,
      json['request_date'] ? new Date(json['request_date']) : null,
      json['delivery_date'] ? new Date(json['delivery_date']) : null,
      json['sent_at'] ? new Date(json['sent_at']) : null,
      json['vat_rate_id'],
      json['ledger_code_id'],
      json['description'],
      json['remark'],
      new Date(json['created_at']),
      new Date(json['updated_at']),
    );
  }
}
